import * as React from 'react';
import {useEffect, useRef, useState} from 'react';
import Molstar from "molstar-react";

// https://stackoverflow.com/a/19014495/16407115
export default function ResponsiveMolstar(props) {
  const ref = useRef(null);
  const [height, setHeight] = useState(0);
  const [width, setWidth] = useState(0);
  
  useEffect(() => {
    function updateSize() {
        setHeight(ref.current.offsetHeight);
        setWidth(ref.current.offsetWidth);
    }
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  return (
    <div ref={ref} style={{height: '100%', width: '100%'}}>
        {height > 0 && width > 0 && <Molstar dimensions={[width-27.5, height-27.5]} {...props} />}
    </div>
  );
}
